<!-- modal -->
<template>
  <!-- 模态框 -->
  <div id="myModal" class="modal" v-show="showModal">
    <!-- 模态内容 -->
    <div class="modal-content">
      <img
        class="close"
        src="@/assets/images/24students/modal-close.svg"
        @click="showModal = false"
        alt="" />
      <img
        src="@/assets/images/24students/recommend-bg2.png"
        class="button"
        alt=""
        @click="showModal = false" />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      submitLoading: false,

      showModal: false
    };
  },
  methods: {}
};
</script>
<style scoped lang="less">
@import './style/RecommendDialog.less';
</style>
